"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Utils = exports.ShipmentDetailsPageState = exports.ManageShipmentsPageState = void 0;
var ceramic_jsx_1 = require("@amzn/ceramic-jsx");
var Constants_1 = require("../../constants/Constants");
var ManageShipmentsPageState = /** @class */ (function () {
    function ManageShipmentsPageState() {
        this.navigationParams = {};
    }
    return ManageShipmentsPageState;
}());
exports.ManageShipmentsPageState = ManageShipmentsPageState;
var ShipmentDetailsPageState = /** @class */ (function () {
    function ShipmentDetailsPageState() {
        this.activePage = 'summary';
        this.activeTab = 0;
    }
    return ShipmentDetailsPageState;
}());
exports.ShipmentDetailsPageState = ShipmentDetailsPageState;
/**
 * Special grout object, each rows data is stored into this object upon row creation.
 * At the navigation time, this object is used to pass the data to the next page. This is
 * done to avoid making a network call to get the data again.
 *
 * Note that when we click on a row based on the context this variable will always hold data for
 * the row that was clicked.
 */
var _rowData;
/**
 * Utility functions for the page. These functions are written in Grout. Although you are typing
 * TypeScript, the functions are written using Grout scripting language.
 *
 * You should read about Grout scripting language on this link: https://builds.selling-partners.amazon.dev/grout/lessons/intro.html
 * Grout is almost similar to JavaScript but, it is not JavaScript. You can use Grout to write functions
 * that can be used in the page.
 */
exports.Utils = {
    __import: {
        name: "Utils",
        type: "script",
        uri: Constants_1.Constants.UtilsPath
    },
    Constants: Constants_1.Constants,
    /*
    * If you are using lists in your Ceramic pages then you would want your list data API to return data in following format:
    * {
    *   data: [],
    *   nextRequest: ""
    * }
    * This function will modify the data returned by the list data API to the format that Ceramic expects.
    *
    */
    modifyListData: function (request, response, state) {
        var listData = {};
        if (response != null && response.data == null && response.errors != null) {
            return {};
        }
        var dataItems = response.recentlyUpdatedShipments;
        for (var index = 0; index < dataItems.size(); index++) {
            var item = dataItems[index];
            var badgeColor = exports.Utils.Constants.Colors.ManageShipmentPageColors.textColor;
            if (item.status == exports.Utils.Constants.ShipmentStatus.DELAYED) {
                badgeColor = exports.Utils.Constants.Colors.ManageShipmentPageColors.orangeBadgeColor;
            }
            else if (item.status == exports.Utils.Constants.ShipmentStatus.COMPLETE) {
                badgeColor = exports.Utils.Constants.Colors.ManageShipmentPageColors.greenBadgeColor;
            }
            item.put('badgeColor', badgeColor);
            var dateTime = item.updateDateTime;
            if (dateTime.contains(",")) {
                var splitDateTime = dateTime.split(",");
                item.put('splitDate', splitDateTime[0].trim());
                item.put('splitTime', splitDateTime[1].trim());
            }
            else {
                item.put('splitDate', dateTime);
                item.put('splitTime', dateTime);
            }
        }
        listData.put('data', dataItems);
        // Currently we are serving static data so nextRequest can be null, but if you are serving paginated data then
        // you would want to return the nextRequest as well.
        var nextRequest = null;
        listData.put('nextRequest', nextRequest);
        return listData;
    },
    /**
     * script to pass data to details page while navigating. This script runs a navigateTo command
     * which is available inside Mosaic SDK. Along with the navigation we are passing some context named
     * navigationParams. This context is used to pass data of the row that was clicked to the details page.
     * This script will also publish a metric once the navigation is complete to the details page.
     * @param url - url where you want to navigate
     */
    navigateToPage: function (url) {
        var core = ceramic_jsx_1.Mosaic.getCompById("SMPCoreComp");
        var rowNavigationParams = ceramic_jsx_1.Grout.mapOf("rowData", _rowData);
        core.executeCommand(ceramic_jsx_1.Grout.mapOf("name", "navigateTo", "parameters", ceramic_jsx_1.Grout.mapOf("routeModel", ceramic_jsx_1.Grout.mapOf("uri", url, "stackItemType", 'Ceramic', "params", ceramic_jsx_1.Grout.mapOf("ctxt", rowNavigationParams)))));
        core.executeCommand(ceramic_jsx_1.Grout.mapOf("name", "log", "parameters", ceramic_jsx_1.Grout.mapOf("name", "GenesisListRowClicked", "value", 1)));
    },
    /**
     * This function is used to set visibility of a component based on the app version.
     * @param minAppVersion - minimum app version for which the component should be visible.
     */
    setVisibilityBasedOnAppVersion: function (minAppVersion) {
        var appVersion = ceramic_jsx_1.Grout.application.version;
        if (appVersion >= minAppVersion) {
            return 'visible';
        }
        else {
            return 'gone';
        }
    }
};
exports.default = (0, ceramic_jsx_1.buildScript)(exports.Utils);
